import { useContext, useEffect, useMemo, useState } from "react";
import { FilterContext } from "src/components/Common/UI/DndTable/TableFilterV2/FilterContext";
import { useGetAllAtmCompanies } from "../api/getAllAtmCompanies";
import { useTranslation } from "react-i18next";

// All your logic is here
export const useAtmCompaniesDataViewLogic = () => {
  const { submitedFilters } = useContext(FilterContext);
  const [modalEvent, setModalEvent] = useState<IEvent>({ action: "", selectedRows: [] });
  const [selectedRowsOfTable, setSelectedRowsOfTable] = useState<IGetAtmCompany []>([]);
  const getAllAtmCompaniesQuery = useGetAllAtmCompanies({data: submitedFilters ? submitedFilters : {}});
  const { t } = useTranslation();

  const loadingDone = [getAllAtmCompaniesQuery].every(
    ({ isFetching  }) => !isFetching
  );

  const errorData = [getAllAtmCompaniesQuery].filter(
    ({ isError }) => (isError ? true : false)
  );

  const data = getAllAtmCompaniesQuery.data ? getAllAtmCompaniesQuery.data : []

  const columns = useMemo(
    () => [
      {
          id: "1",
          Header: "Εταιρία",
          accessor: "description",
          show : true,
          isDraggable: false,
      },
  
    ], []
  );

  const closeActionModal = () => {
    setModalEvent({action: "", selectedRows: []});
  }

  const getModalTitleByAction = (): string => {
    let title = "";
    switch (modalEvent.action) {
      case "create":
        title = t("Δημιουργία Εταιρίας");
        break;
      case "edit":
        title = t("Επεξεργασία Εταιρίας");
        break
        case "delete":
        title = t("Διαγραφή Εταιρίας");
        break
      default:
        break;
    }
    return title;
  }

  const actionEvent = (event: IEvent) => {
    const selectedRows: number[] = selectedRowsOfTable[0] ? [...[selectedRowsOfTable[0].id]] : [];
    console.log("selectedRows", selectedRows, "selectedRowOfTable", selectedRowsOfTable, "selectedRowOfTable[0]", selectedRowsOfTable[0])
    setModalEvent({action: event.action, selectedRows: selectedRows})
  }

  useEffect(()=>{
    setSelectedRowsOfTable([]);
    getAllAtmCompaniesQuery.refetch();
  },[ submitedFilters ])


  return {
    data,
    columns,
    loadingDone,
    selectedRowsOfTable,
    setSelectedRowsOfTable,
    t,
    modalEvent,
    actionEvent,
    closeActionModal,
    getModalTitleByAction
  };
};
